module.exports = __webpack_public_path__ + "media/buhuodan.918007b3.mp3";